module.exports = __webpack_public_path__ + "static/media/tiganitis_logo.1033b8e1.jpg";